export default __webpack_public_path__ + "static/noaa-7fbe83bf43a3e1b9681893cc82ebc43b.svg";